import { Grid } from "@payping/web-components";
import { Outlet } from "react-router";
import { clsx } from "clsx";

const PayLayout = () => {
  const { xs, sm, md, lg, xl, xxl } = Grid.useBreakpoint();

  return (
    <div
      className={clsx([
        "tw:mx-auto tw:h-full tw:w-full",
        {
          "tw:max-w-full": xs,
          "tw:max-w-120 tw:py-12!": sm,
          "tw:max-w-120 tw:py-16.5": md,
          "tw:max-w-xl tw:py-16.5": lg || xl || xxl,
        },
      ])}
    >
      <div
        className={clsx([
          "tw:h-full tw:overflow-auto",
          { "tw:rounded-lg tw:border tw:border-solid tw:border-color-border": !xs },
        ])}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default PayLayout;
